import { gql } from "@apollo/client";

const WEBSITE_USER_APPOINTMENT_QUERY = gql`
query getWebUserAppointment {
  getWebUserAppointment{
      speciesId
      start_at
      reasonForVisit
      appointmentCreateType
      location {
          idLocation
          locationName
          address
          city
          state
          position {
              lat
              lng
          }
          email
          phoneNumber
          timeZone
          background
      }
      messages
      success
  }
}
`;

export default WEBSITE_USER_APPOINTMENT_QUERY;
